// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falSlashForward: CreateIconOptions = {
  "displayName": "FALSlashForward",
  "viewBox": "0, 0, 320, 512",
  "d": "M312.2 2.3c7.6 4.5 10 14.4 5.5 22l-288 480c-4.5 7.6-14.4 10-22 5.5s-10-14.4-5.5-22l288-480c4.5-7.6 14.4-10 22-5.5z"
};
